// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var PaymentCardLogo = require("../common/Components/PaymentCardLogo.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var SetAccountCardDialog = require("./SetAccountCardDialog.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PaymentCardMaskedNumber = require("../common/Components/PaymentCardMaskedNumber.bs.js");
var BillingSettingsPagePaymentCard_accountV5_graphql = require("../../__generated__/BillingSettingsPagePaymentCard_accountV5_graphql.bs.js");
var BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql = require("../../__generated__/BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.bs.js");

var convertFragment = BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, fRef);
}

var CardFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var amex = (require('../../../assets/images/amex.svg'));

var discover = (require('../../../assets/images/discover.svg'));

var mastercard = (require('../../../assets/images/mastercard.svg'));

var visa = (require('../../../assets/images/visa.svg'));

var Logos = {
  amex: amex,
  discover: discover,
  mastercard: mastercard,
  visa: visa
};

function BillingSettingsPagePaymentCard$CardDetails(props) {
  var card = use(props.card);
  var expiresDate = (
    card.expMonth < 10 ? "0" : ""
  ) + card.expMonth.toString() + "/" + card.expYear.toString();
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(DialogV5.make, {
                      title: "Update Payment Card",
                      isOpen: match[0],
                      ariaLabel: "Update Payment Card",
                      onDismiss: (function () {
                          setIsOpen(function (param) {
                                return false;
                              });
                        }),
                      size: "Small",
                      children: JsxRuntime.jsx(SetAccountCardDialog.make, {
                            closeDialog: (function () {
                                setIsOpen(function (param) {
                                      return false;
                                    });
                              })
                          })
                    }),
                JsxRuntime.jsx(PaymentCardLogo.make, {
                      card: card.fragmentRefs,
                      className: "w-14 lg:w-16 flex-shrink-0 overflow-hidden"
                    }),
                JsxRuntime.jsx(PaymentCardMaskedNumber.make, {
                      card: card.fragmentRefs,
                      className: "lg:ml-4 mt-8 lg:mt-0 flex-shrink-0"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Expires ",
                              className: "text-gray-500"
                            }),
                        expiresDate
                      ],
                      className: "lg:ml-10 mt-8 lg:mt-0 flex-shrink-0"
                    }),
                JsxRuntime.jsx("div", {
                      children: Core__Option.getOr(card.name, ""),
                      className: "lg:ml-10 mt-8 lg:mt-0 flex-shrink-0"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                            onClick: (function (param) {
                                setIsOpen(function (param) {
                                      return true;
                                    });
                              }),
                            size: "small",
                            children: "Edit Card"
                          }),
                      className: "flex-grow flex justify-end lg:pl-5 mt-8 lg:mt-0"
                    })
              ],
              className: "p-4 lg:py-5 lg:px-4 border border-gray-300 flex flex-col lg:flex-row items-center text-gray-700"
            });
}

var CardDetails = {
  CardFragment: CardFragment,
  Logos: Logos,
  make: BillingSettingsPagePaymentCard$CardDetails
};

function BillingSettingsPagePaymentCard$AddCard(props) {
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(DialogV5.make, {
                      title: "Add Payment Card",
                      isOpen: match[0],
                      ariaLabel: "Add Payment Card",
                      onDismiss: (function () {
                          setIsOpen(function (param) {
                                return false;
                              });
                        }),
                      size: "Small",
                      children: JsxRuntime.jsx(SetAccountCardDialog.make, {
                            closeDialog: (function () {
                                setIsOpen(function (param) {
                                      return false;
                                    });
                              }),
                            hasExistingCard: false
                          })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        "You haven't registered a credit card",
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    onClick: (function (param) {
                                        setIsOpen(function (param) {
                                              return true;
                                            });
                                      }),
                                    size: "small",
                                    children: "Add a Credit Card"
                                  })
                            })
                      ],
                      className: "flex flex-col gap-4"
                    })
              ]
            });
}

var AddCard = {
  make: BillingSettingsPagePaymentCard$AddCard
};

var convertFragment$1 = BillingSettingsPagePaymentCard_accountV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, fRef);
}

var AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function BillingSettingsPagePaymentCard(props) {
  var match = use$1(props.account);
  var card = match.card;
  if (card !== undefined) {
    return JsxRuntime.jsx(BillingSettingsPagePaymentCard$CardDetails, {
                card: card.fragmentRefs
              });
  } else {
    return JsxRuntime.jsx(BillingSettingsPagePaymentCard$AddCard, {});
  }
}

var View;

var SecondaryButton;

var LinkButton;

var ContentBox;

var PageTitle;

var SubTitle;

var PaymentForm;

var Heading;

var $$Text;

var make = BillingSettingsPagePaymentCard;

exports.View = View;
exports.SecondaryButton = SecondaryButton;
exports.LinkButton = LinkButton;
exports.ContentBox = ContentBox;
exports.PageTitle = PageTitle;
exports.SubTitle = SubTitle;
exports.PaymentForm = PaymentForm;
exports.Heading = Heading;
exports.$$Text = $$Text;
exports.CardDetails = CardDetails;
exports.AddCard = AddCard;
exports.AccountFragment = AccountFragment;
exports.make = make;
/* amex Not a pure module */
